import SvgIcon from "../../SvgIcon/SvgIcon";
import { useProductColors } from "../../../hooks/product/useProductColors";
import ProductColorPopup from "../../Catalog/productColor/ProductColorPopup";

interface Props {
  onColorCreated?: (data: { id?: number; code: string; name: string }) => Promise<void> | void;
  onReload?: () => void;
  message?: string;
}

const QuickAddProductColor: React.FC<Props> = ({
  onColorCreated,
  onReload,
  message = "¿No encuentras el color que buscas? Puedes agregar uno nuevo.",
}) => {

  const {
    isCreateModalOpen,
    openCreateProductColor,
    closeCreateProductColor,
  } = useProductColors();

  return (
    <div className="mt-1 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      {/* Mensaje contextual */}
      <p className="text-gray-600 dark:text-gray-300 text-xs">{message}</p>

      <div className="flex items-center gap-2">
        {/* Botón verde — Recargar */}
        <button
          onClick={onReload}
          type="button"
          className="inline-flex items-center gap-1 rounded bg-[#3CA745] py-1 px-2 text-xs font-medium text-white hover:bg-opacity-90 transition"
        >
          <SvgIcon name="refresh" className="h-3 w-3" />
          Recargar
        </button>

        {/* Botón azul — Nuevo */}
        <button
          onClick={openCreateProductColor}
          type="button"
          className="inline-flex items-center gap-1 rounded bg-primary py-1 px-2 text-xs font-medium text-white hover:bg-opacity-90 transition"
        >
          <SvgIcon name="plus" className="h-3 w-3" />
          Nuevo color
        </button>
      </div>

      {/* Modal */}
      <ProductColorPopup
        isOpen={isCreateModalOpen}
        close={closeCreateProductColor}
        onSubmit={onColorCreated}
      />
    </div>
  );
};

export default QuickAddProductColor;
